import RulesetContext from "../common/ruleset-context";

export default class TennisRulesetContext extends RulesetContext {
    constructor() {
        super();
        this.singlesWonHome = 0;
        this.singlesWonAway = 0;
        this.singleScoringApplied = false;
        this.doublesWonHome = 0;
        this.doublesWonAway = 0;
        this.doubleScoringApplied = false;
    }
}
